import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {
  ActionPanelShowButton,
  useActionPanelShowButtonRef,
} from '../ActionPanelShowButton';

const actionPanelPortalRef = React.createRef<HTMLDivElement>();
/**
 * Returns a ref for rendering the Action Panel via `React.createPortal()`
 * without having to query for a DOM element.
 */
export const useActionPanelPortalRef = () => actionPanelPortalRef;

/**
 * This component is rendering the React Portal target DOM node for the actual
 * `<ActionPanelPortal />`
 */
export function ActionPanelPortalRef() {
  return <div ref={actionPanelPortalRef} style={{ maxWidth: '100%' }} />;
}

type Props = {
  children: JSX.Element;
};
export function ActionPanelPortal(props: Props) {
  const actionPanelShowButtonRef = useActionPanelShowButtonRef();
  if (!actionPanelPortalRef.current) {
    return null;
  }

  // We render the `<ActionPanelShowButton />` in this component since it
  // requires an ActionPanel to be available on the page first.
  const showButton = actionPanelShowButtonRef.current
    ? ReactDOM.createPortal(
        <ActionPanelShowButton />,
        actionPanelShowButtonRef.current,
      )
    : null;

  return ReactDOM.createPortal(
    [showButton, props.children],
    actionPanelPortalRef.current,
  );
}

ActionPanelPortal.propTypes = {
  children: PropTypes.node,
};
